import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Container from 'components/common/Container'

import Box from '@material-ui/core/Box'
import makeStyles from '@material-ui/core/styles/makeStyles'

import BreadCrumbs, { BreadCrumb } from 'components/common/BreadCrumbs'
import LoadingAnimation from 'components/common/LoadingAnimation'
import YoorDoor1 from 'images/yoor_door_1.svg'
import CurrentMonthSales from './CurrentMonthSales'
import DashboardCard from './DashboardCard'

import Dialog from '@material-ui/core/Dialog'
import CloseIcon from '@material-ui/icons/Close'
import HelpIcon from '@material-ui/icons/Help'

import { DashBoardV1, getDashboardV1 } from 'apis/me/DashboardV1'

import { getMe } from 'apis/me'

import alertModules from 'modules/alert'
import { getCognitoId } from 'modules/me'
import { RootState } from 'store'

const useStyles = makeStyles((theme) => ({
  successTextBox: {
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    whiteSpace: 'pre-wrap'
  }
}))
const breadCrumbs: BreadCrumb[] = [{ name: 'ダッシュボード' }]

export default function Index(props: any) {
  let { door_id } = useParams<{
    door_id?: string
  }>()
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()

  const [successText, setSuccessText] = useState('')
  const [loading, setLoading] = useState(true)
  const [dashboard, setDashboard] = useState<DashBoardV1 | null>()
  const params = new URLSearchParams(window.location.search)
  const success = params.get('success')
  const failed = params.get('failed')

  const baseMemberIndexPath = '/management/door/members'
  const baseTransferPath = '/management/sales/transfer/bank'
  const memberIndexPath = door_id === undefined ? baseMemberIndexPath : `/door/${door_id}${baseMemberIndexPath}`
  const transferPath = door_id === undefined ? baseTransferPath : `/door/${door_id}${baseTransferPath}`

  // 集計中フラグ 1日は集計中の判定をする
  const now = new Date().toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' })
  const isAggregate = new Date(now).getDate() === 1

  const cognitoId = useSelector((state: RootState) => getCognitoId(state))

  useEffect(() => {
    const initPage = async () => {
      try {
        const dashboard = await getDashboardV1(door_id)
        setDashboard(dashboard.data)
        setLoading(false)
      } catch {
        history.push('/')
      }
    }
    initPage()

    if (success == 'pricing') {
      setSuccessText('サロン金額が変更されました！')
    } else if (success == 'payment') {
      dispatch(
        alertModules.actions.setAlert({
          text: '振込申請が完了しました！翌々月10日にお振込いたします',
          severity: 'success'
        })
      )
    } else {
      setSuccessText('')
    }

    if (failed == 'payment') {
      dispatch(
        alertModules.actions.setAlert({
          text: '振込申請は未振込の売上が1,000円以上からご利用いただけます',
          severity: 'error'
        })
      )
    }
  }, [])

  /**
   * 振込申請ページへの遷移
   * 口座情報未登録の場合は口座情報登録画面へ
   * @param event
   */
  const toTransferPage = async (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault()
    if (dashboard && dashboard.deposit < 1000) {
      dispatch(
        alertModules.actions.setAlert({
          text: '振込申請は未振込の売上が1,000円以上からご利用いただけます',
          severity: 'error'
        })
      )
      return
    }

    const responseMe = await getMe(door_id)

    if (responseMe.data.user.bank_info) {
      history.push(transferPath)
    } else {
      if (door_id) {
        dispatch(
          alertModules.actions.setAlert({
            text: 'サロンを開設したユーザーが口座情報を登録してください',
            severity: 'error'
          })
        )
      } else {
        history.push({
          pathname: '/management/bank/new',
          state: { referrer: '/management/sales' }
        })
      }
    }
  }

  const [open1, setOpen1] = React.useState(false)

  const handleClickOpen = () => {
    setOpen1(true)
  }

  const handleClose = () => {
    setOpen1(false)
  }

  return (
    <React.Fragment>
      <Container>
        <BreadCrumbsStyled breadcrumbsList={breadCrumbs} />
        <div className="contents">
          <div className="contents-header">
            <h1>
              ダッシュボード
              <HelpIcon className="helpIcon" onClick={handleClickOpen} />
            </h1>
          </div>
          <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open1}
          >
            <section className="modal" id="modal-door">
              <div className="modal-header">
                <div className="close modal-close">
                  <CloseIcon onClick={handleClose} />
                </div>
              </div>
              <div className="modal-contents">
                <div className="mt30 mb30">
                  <div className="mb20">
                    <h3 className="mb1">今月のプラン売上</h3>
                    <p>
                      今月発生したプラン売上からサービス手数料を引いた金額です
                    </p>
                  </div>
                  <div className="mb20">
                    <h3 className="mb1">今月のショップ売上</h3>
                    <p>
                      今月発生したショップ売上からショップ手数料を引いた金額です
                    </p>
                  </div>
                  <div className="mb20">
                    <h3 className="mb1">今月のスクラッチ売上</h3>
                    <p>
                    今月発生したスクラッチ売上からスクラッチ手数料を引いた金額です
                    </p>
                  </div>
                  <div className="mb20">
                    <h3 className="mb1">今月の合計売上</h3>
                    <p>
                    今月発生したプラン・ショップ・スクラッチの売上から手数料を引いた金額です
                    </p>
                  </div>
                  <div className="mb20">
                    <h3 className="mb1">未振込の売上</h3>
                    <p>
                      累計の売上から振込申請済み金額を引いた、振込申請可能な金額です
                    </p>
                  </div>
                  <div className="mb20">
                    <h3 className="mb1">累計の売上</h3>
                    <p>今までに発生した売上の累計金額です</p>
                  </div>
                  <div className="">
                    <h3 className="mb1">発生前売上（一括決済分）</h3>
                    <p>
                      複数月の売上を一括決済するプランにて、まだ経過していない月の売上金額です<br />
                      経過した月の売上が「今月の売上」に反映されます
                    </p>
                  </div>
                  <div className="">
                    <br />
                    <p>※毎月1日は集計処理のため「集計中」表示となります</p>
                  </div>
                </div>
              </div>
            </section>
          </Dialog>
          {(() => {
            if (loading) {
              return <LoadingAnimation />
            } else if (dashboard) {
              return (
                <div className="contents-body">
                  <Box
                    display={successText == '' ? 'none' : ''}
                    className={classes.successTextBox}
                  >
                    {successText}
                  </Box>
                  <CurrentMonthSales
                    sales={dashboard.current_month_sales}
                    isAggregate={isAggregate}
                    title="今月の合計売上"
                  />
                  <DashboardCard
                    title="今月のプラン売上"
                    pricing={dashboard.current_month_plan_sales}
                    isAggregate={isAggregate}
                  />
                  <DashboardCard
                    title="今月のショップ売上"
                    pricing={dashboard.current_month_shop_sales}
                    isAggregate={isAggregate}
                  />
                  <DashboardCard
                    title="今月のスクラッチ売上"
                    pricing={dashboard.current_month_lottery_sales}
                    isAggregate={isAggregate}
                  />
                  <DashboardCard
                    title="未振込の売上"
                    pricing={dashboard.deposit}
                    buttonLabel="振込申請"
                    buttonOnClickFunc={toTransferPage}
                    isAggregate={isAggregate}
                  />
                  <DashboardCard
                    title="累計の売上"
                    pricing={dashboard.total_sales}
                    isAggregate={isAggregate}
                  />
                  <DashboardCard
                    title="発生前売上（一括決済分）"
                    pricing={dashboard.total_pending_sales}
                    isAggregate={isAggregate}
                  />
                  <DashboardCard
                    title="メンバー数"
                    buttonLabel="一覧"
                    unit="人"
                    pricing={dashboard.member_count}
                    isAggregate={false}
                    buttonOnClickFunc={() =>
                      history.push(memberIndexPath)
                    }
                  />
                </div>
              )
            } else {
              return (
                <div>
                  <div>
                    <img src={YoorDoor1} />
                  </div>
                  まだサロンはありません
                </div>
              )
            }
          })()}
        </div>
      </Container>
    </React.Fragment>
  )
}

const BreadCrumbsStyled = styled(BreadCrumbs)`
  max-width: 640px;
  @media (max-width: 640px) {
    margin-bottom: 8px;
    padding: 16px 20px 0;
  }
`